import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faBars,
  faBook,
  faBriefcase,
  faCar,
  faCheck,
  faChevronDown,
  faCircleCheck,
  faCircleMinus,
  faClock,
  faCompass,
  faEnvelope,
  faFilePdf,
  faHandHoldingDollar,
  faHandshakeAngle,
  faHeadset,
  faHeart,
  faHouse,
  faLaptop,
  faLayerGroup,
  faLightbulb,
  faLocationDot,
  faMagnifyingGlass,
  faMapLocationDot,
  faPaperPlane,
  faPhone,
  faPlaneDeparture,
  faPlay,
  faPlus,
  faQuoteLeft,
  faRibbon,
  faShieldHalved,
  faStar,
  faStethoscope,
  faArrowTrendUp,
  faUser,
  faUsers,
  faVolumeHigh,
  faWandMagicSparkles,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

/**
 * Un único punto de entrada para iconografía.
 * Los datos guardan nombres semánticos ("shield", "car") y este
 * mapa decide qué glifo se dibuja, de modo que cambiar de set de
 * iconos no obliga a tocar el contenido.
 */
const ICONS = {
  arrow: faArrowRight,
  book: faBook,
  briefcase: faBriefcase,
  car: faCar,
  check: faCheck,
  "check-circle": faCircleCheck,
  chevron: faChevronDown,
  clock: faClock,
  close: faXmark,
  compass: faCompass,
  facebook: faFacebookF,
  file: faFilePdf,
  handshake: faHandshakeAngle,
  heart: faHeart,
  home: faHouse,
  instagram: faInstagram,
  laptop: faLaptop,
  layers: faLayerGroup,
  lightbulb: faLightbulb,
  mail: faEnvelope,
  map: faMapLocationDot,
  menu: faBars,
  minus: faCircleMinus,
  phone: faPhone,
  money: faHandHoldingDollar,
  pin: faLocationDot,
  plane: faPlaneDeparture,
  play: faPlay,
  plus: faPlus,
  quote: faQuoteLeft,
  ribbon: faRibbon,
  search: faMagnifyingGlass,
  send: faPaperPlane,
  shield: faShieldHalved,
  sound: faVolumeHigh,
  sparkles: faWandMagicSparkles,
  star: faStar,
  stethoscope: faStethoscope,
  support: faHeadset,
  trending: faArrowTrendUp,
  user: faUser,
  users: faUsers,
  whatsapp: faWhatsapp,
};

export default function Icon({ name, className, ...rest }) {
  const icon = ICONS[name];
  if (!icon) return null;
  return (
    <FontAwesomeIcon
      icon={icon}
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}
    />
  );
}
